<template>
  <div/>
</template>

<script>
  import { FA_TOOLTIP, hideTooltip, registerTooltipElement, showTooltip } from '../plugins/Tooltip/Tooltip'
  import {
    windowsComputed,
  } from '@state/helpers'

  export default {
    name: 'FabricTooltip',
    props: {
      id: {
        type: [String],
        default: () => { return '' + Math.floor(Math.random() * Date.now())},
      },
      target: {
        type: String,
        default: '',
      },
      triggers: {
        type: String,
        default: 'hover',
      },
      placement: {
        type: String,
        default: 'top',
      },
      align: {
        type: String,
        default: 'center',
      }
    },
    data() {
      return {
        scrollRoot: document.querySelector("#scroll-root"),
        isVisible: false,
      }
    },
    computed: {
      ...windowsComputed,
    },
    mounted() {
      registerTooltipElement()
      const el = document.getElementById(this.target)
      if (this.triggers.indexOf('hover') !== -1) {
        if (!this.isTablet) {
          el.addEventListener('mouseenter', this.showFabricTooltip);
          el.addEventListener('mouseleave', this.hideFabricTooltip);
        }else{
          document.addEventListener('touchstart', this.toggle);
        }
      }
    },
    beforeUnmount() {
      const el = document.getElementById(this.target)
      if (this.triggers.indexOf('hover') !== -1) {
        if (!this.isTablet) {
          el.removeEventListener('mouseenter', this.showFabricTooltip);
          el.removeEventListener('mouseleave', this.hideFabricTooltip);
        }else{
          document.addEventListener('touchstart', this.toggle);
        }
      }
    },
    methods: {
      showFabricTooltip(event) {
        const el = document.getElementById(this.target)
        el.removeAttribute('title')
        event.target[FA_TOOLTIP] = {
          placement: this.placement,
          align: this.align,
          title: this.$slots.default[0] ? this.$slots.default[0].text : '',
          events: {
            show: () => this.$emit('shown'),
            hide: () => this.$emit('hidden'),
          }
        }
        showTooltip(event)
        if (!this.isTablet) {
          this.scrollRoot.addEventListener('scroll', this.scrollCallback);
        }
        this.isVisible = true
      },
      hideFabricTooltip(event) {
        hideTooltip(event, this.target)
        if (!this.isTablet) {
          this.scrollRoot.removeEventListener('scroll', this.scrollCallback);
        }
        this.isVisible = false
      },
      scrollCallback(event) {
        hideTooltip(event, this.target)
        this.isVisible = false
      },
      toggle(event){
        if (event.path[0].id === this.target){
          if (this.isVisible){
            this.hideFabricTooltip(event)
          }else{
            this.showFabricTooltip(event)
          }
        } else if (this.isVisible){
          this.hideFabricTooltip(event)
        }
      }
    }
  }
</script>
